import { createTheme } from 'flowbite-react';

/**
 * Custom Flowbite-React theme for the Admin Console SPA.
 *
 * Ported from the legacy `wf-adminconsole/app/theme.ts`. The legacy used
 * `tailwind-merge` to splice extra utility classes onto every Flowbite
 * defaults; with Flowbite-React 0.12.x and Tailwind 4 we lean on the
 * library defaults (good enough) and only override the bits the legacy
 * customized that materially change the look — labels (semibold), the
 * dark-theme toggle hover state, tooltip background, and modal padding.
 *
 * Anything not listed here uses the upstream default; that's deliberate
 * — every override is a maintenance burden across Flowbite-React
 * upgrades, so we add overrides only where the visual difference is
 * worth the cost.
 */
export const customTheme = createTheme({
  label: {
    root: {
      base: 'text-sm font-semibold',
    },
  },
  darkThemeToggle: {
    root: {
      base: 'rounded-lg p-2 text-sm text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-4 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-500 dark:focus:ring-gray-500',
    },
  },
});
